// extracted by mini-css-extract-plugin
export default {"root":"AccordionDetails_root__1JjO6"};